import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { AuthContext } from '@/context/AuthContext';
import NavigationBar from './NavigationBar.tsx';

const ProtectedLayout = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-100 dark:bg-gray-950">
      <NavigationBar />
      <main className="app-content flex-1 min-h-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default ProtectedLayout;
